export default __webpack_public_path__ + "static/media/b7.2f6cafd6.jpg";